import { LineSegment2D, Point2D } from '@paragon/geometry-library';

export const GRID_CELL_COUNT = 200;
export const GRID_CELL_SIZE = 12;

export const GRID_WIDTH = GRID_CELL_COUNT * GRID_CELL_SIZE;
export const GRID_HALF_WIDTH = GRID_WIDTH / 2;

const GRID_BOTTOM_LEFT = new Point2D(-GRID_HALF_WIDTH, -GRID_HALF_WIDTH);
const GRID_TOP_LEFT = new Point2D(-GRID_HALF_WIDTH, GRID_HALF_WIDTH);
const GRID_TOP_RIGHT = new Point2D(GRID_HALF_WIDTH, GRID_HALF_WIDTH);
const GRID_BOTTOM_RIGHT = new Point2D(GRID_HALF_WIDTH, -GRID_HALF_WIDTH);

const GRID_LEFT_BOUNDARY = new LineSegment2D(GRID_BOTTOM_LEFT, GRID_TOP_LEFT);
const GRID_TOP_BOUNDARY = new LineSegment2D(GRID_TOP_LEFT, GRID_TOP_RIGHT);
const GRID_RIGHT_BOUNDARY = new LineSegment2D(GRID_TOP_RIGHT, GRID_BOTTOM_RIGHT);
const GRID_BOTTOM_BOUNDARY = new LineSegment2D(GRID_BOTTOM_RIGHT, GRID_BOTTOM_LEFT);

export const GRID_BOUNDARIES = [GRID_LEFT_BOUNDARY, GRID_TOP_BOUNDARY, GRID_RIGHT_BOUNDARY, GRID_BOTTOM_BOUNDARY];
